import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../components/sales/layout/layout";
import Images from "assets/images/imageData";
import ModalPop from 'components/sales/modal/modal';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";
import { Link } from 'react-router-dom';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { Button } from 'react-bootstrap';

const DealerWalletListingApproval = ({
    walletListingDealerApproval,
    listing = []
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [remark, setRemark] = useState("");
    const [actionData, setActionData] = useState();
    const [isModal, setIsModal] = useState(false);
    const [closed, setClosed] = useState(false);

    const handleModalHide = () => {
        setIsModal(false);
        window.location.reload();
    }

    console.log('PAGE::DEALER_WALLET_LISTING');
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await walletListingDealerApproval(1,0)
            setIsLoading(false)
        })()
    }, [])
    
    console.log('PAGE::DEALER APPROVAL');
    const headers = [
        'Dealer Id',
        'Dealer User Id',
        'Business Id',
        'Requested Amount',
        'Attachment',
        'Remark',
        'Requested On',
        'Requested By',
        'Status',
        'Approve/Reject'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await walletListingDealerApproval(val.selected + 1,0);
        setIsLoading(false);
    };

    // {console.log(listing)}
    useEffect(() => {
        const tableData = [
            'id',
            'dealer_id',
            'dealer_user_id',
            'business_id',
            'requested_amount',
            'doc',
            'remark',
            'created_on',
            'created_by_name',
            'status',
            'Approve/Reject', 
        ];
        // console.log('fff ' + JSON.stringify(listing?.data[0]['doc']));
        if (listing && listing?.data !==undefined && listing?.data && listing?.data.length > 0) {
            const data = listing.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ((key === 'status' && element['status'] === 1) ? 
                    {[key]: 'Approved'} : (key === 'status' && element['status'] === 2) ? 
                    {[key]: 'Rejected'} : (key === 'status' && element['status'] === 3) ? 
                    {[key]: 'Approved By Head'} : (key === 'status' && element['status'] === 0) ? 
                    {[key]: 'Pending'} : 
                    key === 'doc' && (element['doc'].split('.').pop() === 'jpeg' || element['doc'].split('.').pop() === 'jpg' || element['doc'].split('.').pop() === 'png') ?
                    {
                        [key]: <a href={element['doc']} target="_blank"><img src={element['doc']}
                                                                                   style={{
                                                                                       "width": "48px",
                                                                                       "borderRadius": "16px",
                                                                                       "height": "48px"
                                                                                   }}/></a>
                    } :
                    key === 'doc' && element['doc'].split('.').pop() === 'doc' ? {
                            [key]: <a href={element['doc']} target="_blank"><img src={Images?.DocIcon}
                                                                                       alt=""
                                                                                       className="view-icon"/></a>
                        } :
                        key === 'doc' && element['doc'].split('.').pop() === 'pdf' ? {
                                [key]: <a href={element['doc']} target="_blank"><img src={Images?.DocIcon}
                                                                                           alt=""
                                                                                           className="view-icon"/></a>
                            } : 
                            {[key]: element[key]}
                     )
                    ),
                    
                )
            );  
            data && setListData(data);
            setPageCount(Math.ceil(listing.total / listing.per_page));
        }
      }, [listing]);

    const headerButtons = () => {
        return (
            <a className="btn btn-primary" href={`${baseUrl}/dm-request`}>Add Request</a>
        )
    }

    const updateApproval = async (data) => {
        setActionData(data);
        if (data.action === 'accept') {
          const payload = {
            id: data.actionObj.id,
            remarks: '',
            actionFor: 'Accept',
            status: 3
          }; 
          //console.log(payload); return false;
          setIsLoading(true);
          (async() => {       
            const url = `${Config.wallet.approveOrReject}`;   
            const { data } = await axios.post(url,payload);
            const res = data?.response?.data;
            if(res === true) {
               setIsLoading(false);
               setIsModal(true);
            } else {
               setIsLoading(false);
               toast.error('Not Approved.');
            }
           })();
        } else {
          setIsModal(true);
          setIsLoading(false);
        }
      };

      const handleContinue = async () => {
        setIsModal(false);
        const payload = {
          id: actionData.actionObj.id,
          remarks: remark,
          actionFor: 'Reject',
          status: 2
        };
        //console.log(payload); return false;
        setIsLoading(true);
        (async() => {       
          const url = `${Config.wallet.approveOrReject}`;   
          const { data } = await axios.post(url,payload);
          const res = data?.response?.data;
          if(res === true) {
             setIsLoading(false);
             setClosed(true);
             window.location.reload();
          } else {
             setIsLoading(false);
             toast.error('Not rejected.');
          }
         })();
      };
    
      const successIconBox = (text, func) => {
        return (
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{text}</h5>
            <Link to="/dashboard/dealer-request-approval" onClick={func} className="btn btn-transparent">
              {'Back to list'}{' '}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        );
      };

    return (
        <>
            <Layout
                title={localization.dealerWallet}
                isLoading={isLoading}
                isGoback={true}
                //Buttons={headerButtons}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={listing?.data && listing?.data?.resultSets}
                    srNo={listing?.from}
                    onChange={(data) => {updateApproval(data)}}
                />
                <ModalPop
                    title={
                    actionData && actionData.action === 'reject'
                        ? localization.rejectConf
                        : localization.conf
                    }
                    show={isModal}
                    handleModalHide={handleModalHide}
                    actionData={actionData}
                >
                {actionData && actionData.action === 'reject' ? (
                <Fragment>
                    <div className="modal-body">
                    <div className="text-center">
                        <h5>{localization.rejectIncentive}</h5>
                        <div className="form-group">
                        <ConstantInput
                            label={localization.addRemark}
                            required
                            isStarRequired={true}
                            type="text"
                            handleChange={(val) => {
                            setRemark(val);
                            }}
                        />
                        </div>
                        <Button
                        className="btn btn-primary"
                        onClick={handleContinue}
                        disabled={!remark}
                        >
                        {localization.continue}{' '}
                        <img src="../images/arrow-right.png" alt="" />
                        </Button>
                    </div>
                    </div>
                </Fragment>
                ) : (
                <Fragment>
                    {successIconBox('Approved', handleModalHide)}
                </Fragment>
                )}
                </ModalPop>
            </Layout>
        </>
    )
}

export default DealerWalletListingApproval;

